/* eslint-disable arrow-body-style */
/* eslint-disable react/prop-types */
import React from 'react';
import Lottie from 'lottie-react';
import iceberg from './Iceberg_Loop_04_Lottie.json';

const Iceberg = (props) => {
    return (
        <Lottie animationData={JSON.parse(JSON.stringify(iceberg))} {...props} />
    );
}

export default Iceberg;



// WEBPACK FOOTER //
// ./frontend/pages/LiveMarkets/animations/iceberg/iceberg.jsx